import { atom } from '@reatom/framework'
import { useAtom } from '@reatom/npm-react'
import { lazy, useEffect } from 'react'
import { usePreviousDistinct, useWindowSize } from 'react-use'
import { useTheme } from 'styled-components'

import { showDebugScreenAtom, showDemoScreenAtom } from '@root/shared'
import { BrowserRouter } from '@root/shared/lib/react-router'

import { DesktopApp } from './ui/desktop/desktop-app'
import { MobileApp } from './ui/mobile/mobile-app'

const DebugScreen = lazy(() =>
  import('@root/screens/debug/debug-screen').then((it) => ({
    default: it.DebugScreen,
  })),
)
const DemoScreen = lazy(() =>
  import('@root/screens/demo/demo-screen').then((it) => ({
    default: it.DemoScreen,
  })),
)

export const appRenderedAtom = atom(false, 'appRenderedAtom')

export const App = () => {
  const theme = useTheme()
  const windowSize = useWindowSize()

  const [showDemoScreen, setShowDemoScreen] = useAtom(showDemoScreenAtom)
  const [showDebugScreen, setShowDebugScreen] = useAtom(showDebugScreenAtom)
  const [_appRendered, setAppRendered] = useAtom(appRenderedAtom)

  const isMobile = windowSize.width < theme.mobile.width
  const prevIsMobile = usePreviousDistinct(isMobile)

  // Forcefully reload page to transition between mobile and desktop
  useEffect(() => {
    if (prevIsMobile === undefined) {
      return
    }

    if (prevIsMobile !== isMobile) {
      window.location.reload()
    }
  }, [isMobile, prevIsMobile])

  useEffect(() => {
    setAppRendered(true)
  }, [setAppRendered])

  return (
    <BrowserRouter>
      {isMobile ? <MobileApp /> : <DesktopApp />}
      {showDemoScreen ? (
        <DemoScreen onClose={() => setShowDemoScreen(false)} />
      ) : undefined}
      {showDebugScreen ? (
        <DebugScreen onClose={() => setShowDebugScreen(false)} />
      ) : undefined}
    </BrowserRouter>
  )
}
